/* eslint-disable no-unused-vars */
import {
  ArrowBackRounded, ExpandLessRounded, ExpandMoreRounded,
} from '@mui/icons-material';
import {
  Alert,
  Box,
  Button, CircularProgress, Container, Divider, IconButton, MenuItem, TextField,
} from '@mui/material';
import moment from 'moment';
import React, {
  useEffect, useState, useRef, useContext,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { getCategories, getConditions, getVolumeUnit } from '../../../../Redux/Models/master';
import {
  finishRequestOut,
  getCourierRequestDetails, updateCourierRequest, validateItems, validatePickup,
} from '../../../../Redux/Models/request';
import { fetchClient, getTotalItems, onlyNumbers } from '../../../../Utils/helpers';
import Elements from '../../../Elements';
import AlertContext from '../../../../Context/AlertContext';
import ConfirmationContext from '../../../../Context/ConfirmationContext';

export default function HistoryDetails({
  classes, error, message, selectedRequest, isLoading, itemsValidated,
}) {
  // const initItem = {
  //   item1: {},
  // };
  const photoPickupRef = useRef(null);
  const photoCustomerRef = useRef(null);
  const requestOut = selectedRequest.type === 'Request Out';
  const requestIn = selectedRequest.type === 'Request In';
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { requestId } = useParams();
  const [activeStep, setActiveStep] = useState(0);
  // const [boxes, setBoxes] = useState({
  //   'box-1': initItem,
  // });
  const [items, setItems] = useState([]);
  const [box, setBox] = useState([]);
  const [popUp, setPopUp] = useState(false);
  const [pickupValidation, setPickupValidation] = useState({
    notes: '',
    photo: '',
  });
  const [customerValidation, setCustomerValidation] = useState({
    notes: '',
    photo: '',
    accepted_by: '-',
    // pickup_item_box_amount: 0,
  });

  const { master } = useSelector((state) => state);
  const { isLoadingVolumeUnit, volumeUnit } = master;

  const { openAlert } = useContext(AlertContext);
  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);

  useEffect(() => {
    dispatch(getCategories());
    dispatch(getConditions());
    dispatch(getVolumeUnit());
  }, []);

  const photoTrigger = (ref) => {
    ref?.current?.click();
  };

  const handleChangePhoto = (type) => (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      const acceptedExt = ['png', 'jpg', 'jpeg', 'gif'];
      const fileExt = file.name.split('.').reverse()[0];

      if (!acceptedExt.includes(fileExt?.toLowerCase())) {
        openAlert({ message: 'Sorry, You only can upload image file', severity: 'error', open: true });
        return;
      }

      const fileSize = file.size;
      if (fileSize > (10000 * 1000)) {
        openAlert({ message: 'Sorry, maximum file size is 10MB', severity: 'error', open: true });
        return;
      }

      openAlert({ message: 'Uploading...', severity: 'info', open: true });
      const body = new FormData();
      body.append('file', file);

      fetchClient({
        method: 'POST',
        url: '/upload',
        data: body,
      }).then((res) => {
        if (type === 'pickup') {
          setPickupValidation({ ...pickupValidation, photo: res.data.data.url });
        } else if (type === 'customer') {
          setCustomerValidation({ ...customerValidation, photo: res.data.data.url });
        }
        openAlert({ message: 'Successfully upload...', severity: 'success', open: true });
      }).catch((err) => {
        openAlert({ message: err.response.data.message, severity: 'error', open: true });
      });
    }
  };

  const nextStep = (next) => {
    setActiveStep(next);
    setPopUp(false);
  };

  useEffect(() => {
    if (!requestId) {
      navigate(-1);
    } else {
      dispatch(getCourierRequestDetails(requestId));
    }
  }, [requestId]);

  useEffect(() => {
    if (itemsValidated) {
      dispatch(getCourierRequestDetails(requestId));
    }
  }, [itemsValidated]);

  useEffect(() => {
    const lastStep = ['Pickup Already Confirm by Customer', 'Arrived at Warehouse', 'Courier Arrived at Customer Place', 'Stored at Warehouse', 'Done'];
    if (requestIn && selectedRequest.status === 'Courier On The Way') {
      nextStep(1);
    } else if (['Courier Arrived at Pickup Place'].indexOf(selectedRequest.status) > -1) {
      nextStep(2);
    } else if (requestOut && selectedRequest.status === 'Courier On The Way') {
      nextStep(3);
    } else if (lastStep.indexOf(selectedRequest.status) > -1) {
      if (['Arrived at Warehouse', 'Stored at Warehouse', 'Courier Arrived at Customer Place', 'Done'].indexOf(selectedRequest.status) > -1) {
        navigate(ROUTES.home());
      }
      nextStep(3);
    } else if (requestOut && selectedRequest.status === 'Request going back to the warehouse') {
      nextStep(4);
    }

    if (selectedRequest.items?.length) {
      setItems(selectedRequest.items);
    }
    if (selectedRequest.box?.length) {
      setBox(selectedRequest.box);
    }
  }, [selectedRequest]);

  const [hideReqInfo, setHideRI] = useState(false);
  const [hideOwnerInfo, setHideOI] = useState(false);
  const [hideItemInfo, setHideII] = useState(false);
  const [hideItemValid, setHideIV] = useState(false);
  const [hideBoxValid, setHideV] = useState(false);

  useEffect(() => {
    if (activeStep === 2) {
      setHideOI(true);
      setHideII(true);
    }
  }, [activeStep]);

  // const addBox = () => {
  //   setBoxes({
  //     ...boxes,
  //     [`box-${Object.keys(boxes).length + 1}`]: initItem,
  //   });
  // };

  const handleChangeItem = (id, newData, type = 'item') => {
    if (type === 'box') {
      setBox(box.map((item) => {
        if (item.id === id) {
          return newData;
        }
        return item;
      }));
    } else if (type === 'item') {
      setItems(items.map((item) => {
        if (item.id === id) {
          if (newData.tempVolume === '-') {
            return { ...newData, volume: `${item.volume} mL` };
          }
          return { ...newData, volume: item.tempVolume };
        }
        return item;
      }));
    }
  };

  const updateStatus = (status) => {
    const body = {
      status,
    };
    dispatch(updateCourierRequest(requestId, body));
    closeConfirmation();
  };

  const getImage = (name, step) => {
    if (step === activeStep) return Images[`${name}Active`];
    if (step > activeStep) return Images[name];
    return Images.Check;
  };

  const renderBtnText = () => {
    switch (activeStep) {
      case 0: return 'Accept pick up request';
      case 1: return 'Already in place';
      case 2: return 'Confirm pickup';
      case 3: return requestOut ? 'Already, Confirm in Customer Place' : 'Already, Confirm in Warehouse';
      case 4: return 'Already in Warehouse, Finish Task';
      default: return '';
    }
  };

  useEffect(() => {
    if (error) {
      openAlert({
        open: true,
        message: `Something went wrong, ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  const handleValidateItems = () => {
    if (requestOut) {
      dispatch(validatePickup(requestId, pickupValidation));
    } else {
      const body = [...items, ...box];
      dispatch(validateItems(requestId, body));
    }
    closeConfirmation();
  };

  const finishTask = () => {
    if (requestIn) {
      updateStatus('Arrived at Warehouse')();
    } else {
      dispatch(finishRequestOut(requestId, customerValidation));
    }
    closeConfirmation();
  };

  const wantToContinue = () => {
    let valid = false;
    switch (activeStep) {
      case 0:
        openConfirmation({
          handleAgree: () => updateStatus('Courier On The Way'),
          handleClose: () => closeConfirmation(),
          desc: 'You will accepting this request task',
          title: 'Accept Request?',
          confirmText: 'Confirm, Accept Request',
          direction: 'row-reverse',
          minWidth: 500,
          maxWidth: 'md',
          btnTextSize: '14px',
        });
        break;
      case 1:
        openConfirmation({
          handleAgree: () => updateStatus('Courier Arrived at Pickup Place'),
          handleClose: () => closeConfirmation(),
          desc: 'Please be detail when checking all items!',
          title: 'Arrived at Address',
          confirmText: 'Confirm',
          direction: 'row-reverse',
          minWidth: 500,
          maxWidth: 'md',
          btnTextSize: '14px',
        });
        break;
      case 2:
        valid = (
          requestIn
          && items.every((item) => item.category_id
            && item.condition_id
            && item.name
            && item.volume
            && item.year
            && item.photo)
          && box.every((item) => item.box_photo)
        ) || (pickupValidation.photo);
        if (!valid) {
          openAlert({
            open: true,
            message: 'Please check and complete pickup validation form!',
            severity: 'error',
          });
        } else {
          openConfirmation({
            handleAgree: () => handleValidateItems(),
            handleClose: () => closeConfirmation(),
            desc: 'Make sure you check and filled up with the right information!',
            title: 'Confirm Picking Up Items?',
            confirmText: 'Yes, Confirm',
            direction: 'row-reverse',
            minWidth: 500,
            maxWidth: 'md',
            btnTextSize: '14px',
          });
        }
        break;
      case 3:
        valid = requestIn
          || (customerValidation.accepted_by && customerValidation.photo);
        if (!valid) {
          openAlert({
            open: true,
            message: 'Please complete the customer confirmation form!',
            severity: 'error',
          });
        } else {
          openConfirmation({
            handleAgree: () => finishTask(),
            handleClose: () => closeConfirmation(),
            desc: 'Recheck again with the Warehouse Admin all your request items, before completing your request task!',
            title: 'Confirm Items Drop at Warehouse?',
            confirmText: 'Yes, Confirm',
            direction: 'row-reverse',
            minWidth: 500,
            maxWidth: 'md',
            btnTextSize: '14px',
          });
        }
        break;
      case 4: updateStatus('Arrived at Warehouse')();
        break;
      default: valid = false;
    }
  };

  const renderRequestInfo = () => (
    <div className="info-card">
      {/* <div className="flex space-between link" onClick={() => setHideRI(!hideReqInfo)}>
        <h3>Request Info</h3>
        {hideReqInfo
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div> */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="inline-flex" flexDirection="column" alignItems="center">
          <img src={selectedRequest.type === 'Request In' ? Images.OenoIn : Images.OenoOut} alt={selectedRequest.type} width="28" height="28" />
          <div className="weight-700 s-12 mt-1 primary-green">
            {selectedRequest.type}
          </div>
        </Box>
        <Box textAlign="right">
          <Box display="inline-flex" gap={2}>
            <Box bgcolor="#D9EDFC" fontSize={14} fontWeight="700" color="#2391D9" py="2px" px={1} borderRadius="4px">{selectedRequest.status}</Box>
            {!!selectedRequest.is_partial
            && <Box bgcolor="#FFF5D9" fontSize={14} fontWeight="700" color="#000" py="2px" px={1} borderRadius="4px">Partial Request Out</Box>}
          </Box>
        </Box>
      </Box>
      {/* <div hidden={hideReqInfo}> */}
      <div>
        <Divider sx={{ my: 2 }} />
        <div className="flex space-between align-items-center space-between mt-3 gap-16">
          <div className="flex-1">
            <div className="mute s-12">Request Service</div>
            <Box
              display="flex"
              gap={0.5}
              mt={1}
              alignItems="center"
            >
              <img alt="delivery" width="24" height="24" src={selectedRequest.delivery_type?.icon === 'warehouse' ? Images.IconHome : Images.IconDelivery} />
              <Box fontWeight="700" fontSize={14}>{selectedRequest.delivery_type?.name || 'Regular'}</Box>
            </Box>
          </div>
          <div className="flex-1">
            <div className="mute s-12">Request ID</div>
            <div className="weight-700 mt-1 s-14">{selectedRequest.id}</div>
          </div>
          <div className="flex-1">
            <div className="mute s-12">Request date</div>
            <div className="weight-700 mt-1 s-14">{moment(selectedRequest.created_at).format('HH.mm - DD/MM/YYYY')}</div>
          </div>
        </div>
      </div>

      <Divider sx={{ my: 2 }} />
      <h3>Delivery Detail</h3>
      <Box mt={2}>
        <div className="flex space-between align-items-center">
          <div>
            <div className="mute s-12">User ID</div>
            <div className="weight-700 mt-1">{selectedRequest.user?.id}</div>
          </div>
        </div>
        <div className="mt-3">
          <div className="mute s-12">Customer Name</div>
          <div className="weight-700 mt-1">
            {/* {selectedRequest.user?.front_name}
            {' '}
            {selectedRequest.user?.back_name} */}
            {selectedRequest.pickup_address?.name}
          </div>
        </div>
        {activeStep !== 0
          && (
            <div className="flex space-between align-items-center mt-3">
              <div>
                <div className="mute s-12">Phone number</div>
                <div className="weight-700 mt-1">{selectedRequest.pickup_address?.phone_number}</div>
              </div>
              <img src={Images.PhoneOrange} alt="phone" className="link" onClick={() => window.open(`tel:${selectedRequest.pickup_address?.phone_number}`)} />
            </div>
          )}
        <div className="flex space-between align-items-center mt-3">
          <div>
            <div className="mute s-12">Pick up address</div>
            <div className="weight-700 mt-1">
              {selectedRequest.pickup_address?.address}
              ,
              {' '}
              {selectedRequest.pickup_address?.city}
              ,
              {' '}
              {selectedRequest.pickup_address?.province}
              ,
              {' '}
              {selectedRequest.pickup_address?.country}
              ,
              {' '}
              {selectedRequest.pickup_address?.postal_code}
            </div>
          </div>
          <img
            src={Images.LocationOrange}
            alt="Pick up address"
            className="link"
            onClick={() => {
              window.open(`http://maps.google.com/?q${selectedRequest.pickup_address?.address}, ${selectedRequest.pickup_address?.city}, ${selectedRequest.pickup_address?.province}, ${selectedRequest.pickup_address?.country}, ${selectedRequest.pickup_address?.postal_code}`);
            }}
          />
        </div>
      </Box>
    </div>
  );

  const renderItemInfo = () => (
    <div className="info-card mt-4">
      <div className="flex space-between">
        <h3>Item Details</h3>
      </div>
      <div>
        <Divider sx={{ my: 2 }} />
        <Box flex={1}>
          <Box className="s-14 mute">Total Items</Box>
          <Box mt={0.5}>
            <Box fontWeight="700" fontSize={14}>
              {
                getTotalItems(selectedRequest)
              }
            </Box>
          </Box>
        </Box>
        {selectedRequest.items?.map(((item, i) => (
          <BoxItemData
            key={i}
            index={i}
            data={item}
          />
        )))}
        {selectedRequest.box?.map(((item, i) => (
          <BoxBoxData
            key={i}
            index={i}
            data={item}
          />
        )))}
      </div>

    </div>
  );

  const renderItemValidation = () => (
    <div className="info-card mt-4">
      <div>
        <div className="flex space-between link" onClick={() => setHideIV(!hideItemValid)}>
          <h3>
            Item validation
          </h3>
          {hideItemValid
            ? <ExpandMoreRounded fontSize="medium" />
            : <ExpandLessRounded fontSize="medium" />}
        </div>
        {/* <div className="mute s14 mt-1">1 box only carried 6 items</div> */}

        <div hidden={hideItemValid}>
          <Divider sx={{ mt: 2 }} />
          {items.map((item, i) => (
            <BoxItemForm
              key={i}
              index={i}
              item={item}
              onFieldChange={(newData) => handleChangeItem(item.id, newData, 'item')}
              setSnackbar={openAlert}
              isLoadingVolumeUnit={isLoadingVolumeUnit}
              volumeUnit={volumeUnit}
            />
          ))}

          {/* {items.length < 6
          && (
          <Button fullWidth
          size="small" sx={{ mt: 2 }} variant="outlined" className="btn-outlined" onClick={addItem}>
            Add 1 item field
          </Button>
          )} */}
        </div>
      </div>
    </div>
  );

  const renderItemsData = () => (
    <div className="info-card mt-4">
      <div>
        <div className="flex space-between link" onClick={() => setHideIV(!hideItemValid)}>
          <h3>
            Item Validation
          </h3>
          {hideItemValid
            ? <ExpandMoreRounded fontSize="medium" />
            : <ExpandLessRounded fontSize="medium" />}
        </div>

        <div hidden={hideItemValid}>
          <Divider sx={{ mt: 2 }} />
          {items.map((item, i) => (
            <BoxItemData
              key={i}
              index={i}
              data={item}
            />
          ))}
          {box.map((item, i) => (
            <BoxBoxData
              key={i}
              index={i}
              data={item}
            />
          ))}
        </div>
      </div>
    </div>
  );

  const renderBoxValidation = () => (
    <div className="info-card mt-4">
      <div>
        <div className="flex space-between link" onClick={() => setHideV(!hideBoxValid)}>
          <h3>
            Box validation
          </h3>
          {hideBoxValid
            ? <ExpandMoreRounded fontSize="medium" />
            : <ExpandLessRounded fontSize="medium" />}
        </div>

        <div hidden={hideBoxValid}>
          <Divider sx={{ mt: 2 }} />
          {box.map((item, i) => (
            <BoxForm
              key={i}
              index={i}
              item={item}
              onFieldChange={(newData) => handleChangeItem(item.id ?? item.box_id, newData, 'box')}
              setSnackbar={openAlert}
            />
          ))}
        </div>
      </div>
    </div>
  );

  const renderCustomerValidation = () => (
    <div className="info-card mt-4">
      <h3>
        Customer confirmation
      </h3>

      <div className="mt-3">
        <label>Accepted by</label>
        <TextField
          fullWidth
          size="small"
          value={customerValidation.accepted_by}
          onChange={({ target }) => setCustomerValidation({
            ...customerValidation,
            accepted_by: target.value,
          })}
          select
        >
          <MenuItem value="Own customer">Own customer</MenuItem>
          <MenuItem value="Customer family member">Customer family member</MenuItem>
          <MenuItem value="Security officer in building">Security officer in building</MenuItem>
          <MenuItem value="Mail box">Mail box</MenuItem>
          <MenuItem value="Others">Others</MenuItem>
        </TextField>
      </div>

      {/* {!!selectedRequest.box
      && (
      <div className="mt-3">
        <label>Box amount</label>
        <TextField
          fullWidth
          size="small"
          value={customerValidation.pickup_item_box_amount}
          onChange={({ target }) => setCustomerValidation({
            ...customerValidation,
            pickup_item_box_amount: Number(onlyNumbers(target.value)),
          })}
        />
      </div>
      )} */}

      <div className="mt-3">
        <label>Notes (optional)</label>
        <TextField
          fullWidth
          size="small"
          value={customerValidation.notes}
          onChange={({ target }) => setCustomerValidation({
            ...customerValidation,
            notes: target.value,
          })}
        />
      </div>

      <div className="mt-3">
        <div>Photo</div>
        <div className="mute s-14 mt-1">You can only add 1 photo</div>
        <div className="mt-2">
          <input type="file" name="photo" hidden ref={photoCustomerRef} onChange={handleChangePhoto('customer')} />
          {customerValidation.photo
            ? (
              <img
                onClick={() => photoTrigger(photoCustomerRef)}
                width="120"
                height="120"
                alt="profile"
                src={customerValidation.photo}
                className="rounded link"
              />
            ) : (
              <div className="upload-sect" onClick={() => photoTrigger(photoCustomerRef)}>
                Photo
              </div>
            )}
        </div>
      </div>
    </div>
  );

  return (
    <Elements.CourierPageBase noNav navigate={navigate}>
      <div className={`${classes.root} no-scrollbar`}>
        <section className={`${classes.linearSection} sticky`}>
          <Container>
            <div className="flex space-between align-items-center">
              <h1>
                <img src={Images.LogoWhite} alt="Oeno Bank" height={36} />
              </h1>
            </div>
            <Box mt={5}>
              <Box className="flex align-items-center" onClick={() => navigate(-1)} sx={{ cursor: 'pointer' }}>
                <IconButton sx={{ p: 0 }}>
                  <ArrowBackRounded className="white" />
                </IconButton>
                <h4 className="white">Detail Request</h4>
              </Box>
            </Box>
          </Container>
        </section>
        {/* <Box sx={{ bgcolor: '#FCFCFF' }}>
          <div hidden={activeStep === 0}>
            <div className="flex flex-center align-items-center gap-24">
              <div className="center">
                <img src={getImage('Person', 1)} alt="Pickup data" />
                <div className={`mt-1 s-12 ${activeStep === 1 && 'linear-red-text weight-700'}`}>
                Pickup data</div>
              </div>
              <img src={Images.Divider} alt="Divider" />
              <div className="center">
                <img src={getImage('DataCheck', 2)} alt="Pickup validation" />
                <div
                className={`mt-1 s-12 ${activeStep === 2 && 'linear-red-text weight-700'}`}>
                Pickup validation</div>
              </div>
              <img src={Images.Divider} alt="Divider" />
              <div className="center">
                <img
                src={getImage(requestOut ? 'CustomerDrop' : 'WarehouseValidate', 3)}
                alt="Warehouse drop" height={requestIn ? '32' : '28'} />
                <div
                className={`s-12 ${activeStep === 3 && 'linear-red-text weight-700'}`}>
                {requestOut ? 'Customer drop' : 'Warehouse drop'}</div>
              </div>
            </div>
          </div>
        </Box> */}

        <Box component={Container} position="relative" zIndex={2} mt={-4}>
          {renderRequestInfo()}
          {/* {renderDeliveryDetail()} */}
          {renderItemInfo()}

          {Boolean(activeStep === 2 && requestIn && selectedRequest.items?.length > 0)
            && renderItemValidation()}
          {Boolean(activeStep === 3 && requestIn && selectedRequest.items?.length > 0)
            && renderItemsData()}

          {Boolean(activeStep === 2 && (requestOut
          || (requestIn && selectedRequest.box?.length > 0)))
            && renderBoxValidation()}
          {Boolean(activeStep === 3 && requestOut)
            && renderCustomerValidation()}

          {/* <div className="mt-3" hidden={activeStep !== 2 || requestOut}>
            <Button fullWidth size="small"
            variant="outlined" className="btn-outlined" onClick={addBox}>
              Add Box
              {' '}
              {Object.keys(boxes).length + 1}
            </Button>
          </div> */}
        </Box>

        <Container className="floating-action">
          <Box className="flex">
            {Boolean([2, 3].includes(activeStep))
                && (
                  <Button fullWidth size="large" variant="outlined" className="btn-outlined" onClick={() => setActiveStep(activeStep - 1)}>
                    Back
                  </Button>
                )}
            <Button fullWidth size="large" variant="contained" className="btn-contained" onClick={wantToContinue} disabled={isLoading} startIcon={isLoading && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)}>
              {renderBtnText()}
            </Button>
          </Box>
        </Container>
      </div>

      {/* <Elements.ConfirmationModal
        maxWidth="md"
        open={popUp && activeStep === 0}
        desc={(
          <div className="height-14">
            Accept Request?
            <br />
            You will accepting this request task
          </div>
        )}
        handleClose={() => setPopUp(false)}
        handleAgree={() => updateStatus('Courier On The Way')}
        confirmText="Accept"
        isLoading={isLoading}
      /> */}
      {/* <Elements.ConfirmationModal
        maxWidth="md"
        open={popUp && activeStep === 2}
        desc={(
          <div className="center height-14">
            Make sure pickup data
            <br />
            already filled up!
          </div>
        )}
        handleClose={() => setPopUp(false)}
        handleAgree={handleValidateItems}
        confirmText="Confirm"
        isLoading={isLoading}
      /> */}
      {/* <Elements.ConfirmationModal
        maxWidth="md"
        open={popUp && activeStep === 3}
        desc={(
          <div className="center height-14">
            Do you sure want to
            <br />
            finish this request task?
          </div>
        )}
        handleClose={() => setPopUp(false)}
        handleAgree={finishTask}
        confirmText="Finish"
        isLoading={isLoading}
      /> */}
      <Elements.ConfirmationModal
        maxWidth="md"
        open={popUp === 2}
        desc={(
          <div className="center height-14">
            Are you sure want to
            <br />
            Decline this request order?
          </div>
        )}
        handleAgree={() => setPopUp(0)}
        handleClose={() => setPopUp(3)}
        confirmText="Cancel"
        cancelText="Declined"
      />
      <Elements.ModalBase
        maxWidth="md"
        open={popUp === 3}
        handleAgree={() => setPopUp(0)}
        handleClose={() => setPopUp(0)}
        confirmText="Cancel"
        cancelText="Send"
      >
        <div className="s-16 weight-700 center height-14">
          Tell us why you
        </div>
        <div className="s-16 weight-700 center height-14">
          Declined the request order?
        </div>
        <div className="mt-3">
          <TextField fullWidth placeholder="Notes" multiline />
        </div>
      </Elements.ModalBase>
    </Elements.CourierPageBase>
  );
}

export function BoxItemForm({
  index, setSnackbar, onFieldChange, item, isLoadingVolumeUnit, volumeUnit,
}) {
  const photoRef = useRef(null);
  const { master } = useSelector((state) => state);

  const [hide, setHide] = useState(false);
  const toggleHide = () => {
    setHide(!hide);
  };

  const [fields, setField] = useState(() => ({ ...item, tempVolume: item.volume }) || {
    name: '',
    photo: '',
    description: '',
    volume: '',
    tempVolume: '',
    category_id: '-',
    condition_id: '-',
    notes: '',
    year: 0,
  });

  useEffect(() => {
    onFieldChange(fields);
  }, [fields]);

  const handleChangeField = (e) => {
    setField({ ...fields, [e.target.name]: e.target.value });
  };

  const photoTrigger = (ref) => {
    ref?.current?.click();
  };

  const handleChangePhoto = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      const acceptedExt = ['png', 'jpg', 'jpeg', 'gif'];
      const fileExt = file.name.split('.').reverse()[0];

      if (!acceptedExt.includes(fileExt?.toLowerCase())) {
        setSnackbar({ message: 'Sorry, You only can upload image file', severity: 'error', open: true });
        return;
      }

      const fileSize = file.size;
      if (fileSize > (10000 * 1000)) {
        setSnackbar({ message: 'Sorry, maximum file size is 10MB', severity: 'error', open: true });
        return;
      }

      setSnackbar({ message: 'Uploading...', severity: 'info', open: true });
      const body = new FormData();
      body.append('file', file);

      fetchClient({
        method: 'POST',
        url: '/upload',
        data: body,
      }).then((res) => {
        setField({ ...fields, photo: res.data.data.url });
        setSnackbar({ message: 'Successfully upload...', severity: 'success', open: true });
      }).catch((err) => {
        setSnackbar({ message: err.response.data.message, severity: 'error', open: true });
      });
    }
  };

  return (
    <div style={{ borderRadius: 8, border: '1px solid #DADADA', padding: 16 }} className="mt-3">
      <div className="flex space-between align-items-center link" onClick={toggleHide}>
        <h4>
          Item
          {' '}
          {index + 1}
        </h4>
        {hide
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>
      <div hidden={hide}>
        <Divider sx={{ mt: 2 }} />
        <div className="mt-3">
          <label>Wine name</label>
          <TextField fullWidth size="small" placeholder="Item name" value={fields.name} name="name" onChange={handleChangeField} />
        </div>

        <div className="mt-3">
          <label>Year</label>
          <TextField
            value={fields.year}
            name="year"
            sx={{ mt: 0.5 }}
            size="small"
            placeholder="Type the year"
            fullWidth
            onChange={(e) => setField({ ...fields, year: Number(onlyNumbers(e.target.value)) })}
          />
        </div>

        <div className="mt-3">
          <label>Wine volume</label>
          <TextField
            sx={{ mt: 0.5 }}
            size="small"
            placeholder="0"
            fullWidth
            value={fields.tempVolume}
            name="tempVolume"
            type="number"
            onChange={handleChangeField}
            select
          >
            <MenuItem value="0" disabled>{isLoadingVolumeUnit ? 'Loading...' : 'Choose wine volume'}</MenuItem>
            {volumeUnit.map((unit) => (
              <MenuItem value={unit.option} key={unit.id}>{unit.option}</MenuItem>
            ))}
            <MenuItem value="-">Other</MenuItem>
          </TextField>
          {fields.tempVolume === '-'
          && (
            <TextField
              value={fields.volume}
              InputProps={{
                endAdornment: 'ml',
              }}
              sx={{ flex: 3, mt: 0.5 }}
              size="small"
              placeholder="Type your wine volume"
              fullWidth
              onChange={(e) => setField({ ...fields, volume: Number(onlyNumbers(e.target.value)) })}
              name="volume"
            />
          )}
        </div>

        <div className="mt-3">
          <label>Category</label>
          <TextField size="small" fullWidth select value={fields.category_id} name="category_id" onChange={handleChangeField}>
            <MenuItem value="-" disabled>Choose category</MenuItem>
            {master.categories.map((category) => (
              <MenuItem value={category.id} key={category.id}>{category.name}</MenuItem>
            ))}
          </TextField>
        </div>

        <div className="mt-3">
          <label>Condition</label>
          <TextField size="small" fullWidth select value={fields.condition_id} name="condition_id" onChange={handleChangeField}>
            <MenuItem value="-" disabled>Choose condition</MenuItem>
            {master.conditions.map((condition) => (
              <MenuItem value={condition.id} key={condition.id}>{condition.name}</MenuItem>
            ))}
          </TextField>
        </div>

        <div className="mt-3">
          <label>Notes (optional)</label>
          <TextField fullWidth size="small" placeholder="Notes" value={fields.notes} name="notes" onChange={handleChangeField} />
        </div>

        <div className="mt-3">
          <div>Photo</div>
          <div className="mute s-14 mt-1">You can only add 1 photo per item</div>
          <div className="mt-2">
            <input type="file" name="photo" hidden ref={photoRef} onChange={handleChangePhoto} />
            {fields.photo
              ? (
                <img
                  onClick={() => photoTrigger(photoRef)}
                  width="120"
                  height="120"
                  alt="profile"
                  src={fields.photo}
                  className="rounded link"
                />
              ) : (
                <div className="upload-sect" onClick={() => photoTrigger(photoRef)}>
                  Photo
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}

export function BoxForm({
  index, setSnackbar, onFieldChange, item,
}) {
  const photoRef = useRef(null);
  const [hide, setHide] = useState(false);
  const toggleHide = () => {
    setHide(!hide);
  };

  const [fields, setField] = useState(() => (item ? {
    box_id: item.id,
    box_photo: item.photo,
    box_notes: item.notes,
    id: item.id,
  } : {
    box_id: '',
    box_photo: '',
    box_notes: '',
  }));

  useEffect(() => {
    onFieldChange(fields);
  }, [fields]);

  const handleChangeField = (e) => {
    setField({ ...fields, [e.target.name]: e.target.value });
  };

  const photoTrigger = (ref) => {
    ref?.current?.click();
  };

  const handleChangePhoto = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      const acceptedExt = ['png', 'jpg', 'jpeg', 'gif'];
      const fileExt = file.name.split('.').reverse()[0];

      if (!acceptedExt.includes(fileExt?.toLowerCase())) {
        setSnackbar({ message: 'Sorry, You only can upload image file', severity: 'error', open: true });
        return;
      }

      const fileSize = file.size;
      if (fileSize > (10000 * 1000)) {
        setSnackbar({ message: 'Sorry, maximum file size is 10MB', severity: 'error', open: true });
        return;
      }

      setSnackbar({ message: 'Uploading...', severity: 'info', open: true });
      const body = new FormData();
      body.append('file', file);

      fetchClient({
        method: 'POST',
        url: '/upload',
        data: body,
      }).then((res) => {
        setField({ ...fields, box_photo: res.data.data.url });
        setSnackbar({ message: 'Successfully upload...', severity: 'success', open: true });
      }).catch((err) => {
        setSnackbar({ message: err.response.data.message, severity: 'error', open: true });
      });
    }
  };

  return (
    <div style={{ borderRadius: 8, border: '1px solid #DADADA', padding: 16 }} className="mt-3">
      <div className="flex space-between align-items-center link" onClick={toggleHide}>
        <h4>
          Box
          {' '}
          {index + 1}
        </h4>
        {hide
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>
      <div hidden={hide}>
        <Divider sx={{ mt: 2 }} />
        <div className="mt-3">
          <label>Notes (Optional)</label>
          <TextField fullWidth size="small" placeholder="Notes" value={fields.notes} name="box_notes" onChange={handleChangeField} />
        </div>

        <div className="mt-3">
          <div>Photo (Required)</div>
          <div className="mute s-14 mt-1">You can only add 1 photo per item</div>
          <div className="mt-2">
            <input type="file" name="box_photo" hidden ref={photoRef} onChange={handleChangePhoto} />
            {fields.box_photo
              ? (
                <img
                  onClick={() => photoTrigger(photoRef)}
                  width="120"
                  height="120"
                  alt="profile"
                  src={fields.box_photo}
                  className="rounded link"
                />
              ) : (
                <div className="upload-sect" onClick={() => photoTrigger(photoRef)}>
                  Photo
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}

export function BoxItemData({ index, data }) {
  const [hide, setHide] = useState(false);
  const { master } = useSelector((state) => state);
  const toggleHide = () => {
    setHide(!hide);
  };

  const [fields, setField] = useState({
    name: '',
    photo: '',
    description: '',
    year: '',
    volume: 0,
    category_id: '-',
    condition_id: '-',
    notes: '',
  });

  useEffect(() => {
    setField(data);
  }, [data]);

  const renderCategory = () => {
    const selectedCategory = master.categories.filter((cat) => cat.id === fields.category_id);
    if (selectedCategory[0]) {
      return selectedCategory[0].name;
    }

    return '-';
  };

  const renderCondition = () => {
    const selectedCondition = master.conditions.filter((con) => con.id === fields.condition_id);
    if (selectedCondition[0]) {
      return selectedCondition[0].name;
    }

    return '-';
  };

  return (
    <div style={{ borderRadius: 8, border: '1px solid #DADADA', padding: 16 }} className="mt-3">
      <div className="flex space-between align-items-center link" onClick={toggleHide}>
        <h4>
          Item
          {' '}
          {index + 1}
        </h4>
        {hide
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>
      <div hidden={hide}>
        <Divider sx={{ mt: 2 }} />
        <div className="mt-3">
          <div className="mute mt-2">Wine name</div>
          <div className="weight-700 mt-1 s-16">{fields.name}</div>
        </div>

        <div className="mt-3">
          <div className="mute mt-2">Year of the Wine</div>
          <div className="weight-700 mt-1 s-16">
            {fields.year}
          </div>
        </div>

        <div className="mt-3">
          <div className="mute mt-2">Wine volume</div>
          <div className="weight-700 mt-1 s-16">
            {fields.volume}
          </div>
        </div>

        <div className="mt-3">
          <div className="mute mt-2">Category</div>
          <div className="weight-700 mt-1 s-16">{renderCategory(fields.category_id)}</div>
        </div>

        <div className="mt-3">
          <div className="mute mt-2">Condition</div>
          <div className="weight-700 mt-1 s-16">{renderCondition(fields.condition_id)}</div>
        </div>

        <div className="mt-3">
          <div className="mute mt-2">Notes</div>
          <div className="weight-700 mt-1 s-16">{fields.notes || '-'}</div>
        </div>

        <div className="mt-3">
          <div className="mute mt-2">Photo</div>
          <div className="mt-2">
            {fields.photo
              ? (
                <img
                  width="120"
                  height="120"
                  alt="product"
                  src={fields.photo}
                  className="rounded"
                />
              ) : '-'}
          </div>
        </div>
      </div>
    </div>
  );
}

export function BoxBoxData({ index, data }) {
  const [hide, setHide] = useState(false);
  const toggleHide = () => {
    setHide(!hide);
  };

  return (
    <div style={{ borderRadius: 8, border: '1px solid #DADADA', padding: 16 }} className="mt-3">
      <div className="flex space-between align-items-center link" onClick={toggleHide}>
        <h4>
          Box
          {' '}
          {index + 1}
        </h4>
        {hide
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>
      <div hidden={hide}>
        <Divider sx={{ mt: 2 }} />
        <div className="mt-3">
          <div className="mute mt-2">Box name</div>
          <div className="weight-700 mt-1 s-16">{data.name}</div>
        </div>
        <div className="mt-3">
          <div className="mute mt-2">Amount</div>
          <div className="weight-700 mt-1 s-16">{data.amount}</div>
        </div>
        <div className="mt-3">
          <div className="mute mt-2">Notes</div>
          <div className="weight-700 mt-1 s-16">{data.notes || '-'}</div>
        </div>
        <div className="mt-3">
          <div className="mute mt-2">Photo</div>
          <div className="mt-2">
            {data.photo
              ? (
                <img
                  width="120"
                  height="120"
                  alt="product"
                  src={data.photo}
                  className="rounded"
                />
              ) : '-'}
          </div>
        </div>
      </div>
    </div>
  );
}
